export const convertToYoutubeEmbedUrl = (url: string, videoId: string, startSec: number = 0): string => {
  if (!videoId) {
    return "";
  }

  const origin = typeof window !== 'undefined' ? window.location.origin : '';

  try {
    const urlObj = new URL(url);
    const existingParams = new URLSearchParams(urlObj.search);

    existingParams.set('start', startSec.toString());
    existingParams.set('enablejsapi', '1');
    existingParams.set('origin', origin);
    existingParams.set('rel', '0');

    return `https://www.youtube.com/embed/${videoId}?${existingParams.toString()}`;
  } catch (error) {
    return `https://www.youtube.com/embed/${videoId}?start=${startSec}&enablejsapi=1&origin=${origin}&rel=0`;
  }
};
